import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCustomizeSpaceDrawer } from "@circle-react/components/Drawers/CustomizeSpaceDrawer";
import { useCurrentSpaceContext } from "@circle-react/contexts";

const deeplinkSectionMap = {
  lockscreen: t("customize_space.lock_screen"),
  customize: t("customize_space.customize"),
  options: t("customize_space.options"),
};

const isValidSection = (
  section: string,
): section is keyof typeof deeplinkSectionMap =>
  !!section && Object.keys(deeplinkSectionMap).includes(section);

export const useCustomizeSpaceDeeplink = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    show: showCustomizeSpaceDrawer,
    visible: isCustomizeSpaceDrawerVisible,
  } = useCustomizeSpaceDrawer();
  const { refetch, data: space } = useCurrentSpaceContext();

  useEffect(() => {
    try {
      const editParam = new URLSearchParams(location.search)
        .get("edit")
        ?.toLowerCase();

      if (!editParam || !isValidSection(editParam)) return;

      const requestedSection = deeplinkSectionMap[editParam];

      if (isCustomizeSpaceDrawerVisible || !space?.id || !requestedSection)
        return;

      void showCustomizeSpaceDrawer({
        spaceId: space.id,
        initialSection: requestedSection,
        refetch: () => void refetch(),
      });

      const url = new URL(window.location.href);
      if (url.searchParams.has("edit")) {
        url.searchParams.delete("edit");
        history.replace(`${url.pathname}${url.search}${url.hash}`);
      }
    } catch (error) {
      console.error(error);
    }
  }, [
    location.search,
    showCustomizeSpaceDrawer,
    isCustomizeSpaceDrawerVisible,
    history,
    refetch,
    space?.id,
  ]);
};
